import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getWitnesses } from 'services/witness-service';

interface WitnessesState {
  witnesses: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: WitnessesState = {
  witnesses: [],
  isLoading: false,
  error: null,
};

export const fetchWitnesses = createAsyncThunk(
  'witnesses/fetchWitnesses',
  async (_, { rejectWithValue }) => {
    try {
      const data = await getWitnesses(100);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch witnesses');
    }
  }
);

const witnessesSlice = createSlice({
  name: 'witnesses',
  initialState,
  reducers: {
    // We can add local reducers if we want to manually update the list after voting
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWitnesses.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWitnesses.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.isLoading = false;
        state.witnesses = action.payload;
      })
      .addCase(fetchWitnesses.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default witnessesSlice.reducer;
